module.exports = "/img/_/_/_/assets/images/creeper/book/rare//15.jpg?7e1adaef62138bbfa442304bd36dde4f";